import { SbBlokData } from "@storyblok/js";
import { useGeneralSettings } from "../../hooks/use-general-settings";
import { StoryblokComponent } from "@made-people/grease-storyblok";
import { useMinicartRecommendations } from "../../hooks/use-minicart-recommendations";
import { SearchResult, SearchResultProvider } from "@made-people/grease-search";
import { MiniCartSwipeableProductList } from "../blueprint/swipeable-product-list/mini-cart-swipeable/default-props";

export const MMMinicartUpsellSkeleton = () => {
  return (
    <div className="w-full animate-pulse lg:px-2 lg:py-5" aria-hidden="true">
      <div className="mb-4 flex flex-col gap-2">
        <div className="h-4 w-40 rounded-full bg-surface-2" />
      </div>
      <div className="grid grid-cols-2 gap-3">
        {Array.from({ length: 2 }).map((_, index) => (
          <div key={index} className="flex flex-col gap-3">
            <div className="aspect-[5/7] rounded-md bg-surface-2" />
            <div className="flex flex-col gap-2">
              <div className="h-3 w-full rounded-full bg-surface-2" />
              <div className="h-3 w-3/4 rounded-full bg-surface-2" />
              <div className="h-3 w-1/3 rounded-full bg-surface-2" />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export const MMMinicartUpsell = () => {
  const generalSettings = useGeneralSettings();
  const { recommendations, loading } = useMinicartRecommendations("standard");

  const storyblokContent = generalSettings?.miniCartUpsellContent?.map(
    (component: SbBlokData, index: number) => (
      <StoryblokComponent key={index} blok={component} />
    ),
  );

  if (!recommendations.length) {
    if (loading) return <MMMinicartUpsellSkeleton />;
    return storyblokContent;
  }

  const searchResult: SearchResult = {
    items: recommendations.map((product) => ({
      type: "product",
      product,
    })),
    meta: {
      currentPage: 1,
      totalPages: 1,
      itemsPerPage: recommendations.length,
      totalItems: recommendations.length,
    },
    sort: [],
    facets: [],
  };
  return (
    <SearchResultProvider result={searchResult}>
      <MiniCartSwipeableProductList
        settings={{
          template: "template1",
          headerSettings: {
            heading: {
              heading: "Mini_Cart_Recommendations_Heading",
            },
          },
        }}
      />
    </SearchResultProvider>
  );
};
